/** @const gsap */
/** @const ScrollTrigger */

document.addEventListener("DOMContentLoaded", (event) => {
    const stickySlider = document.querySelectorAll(".ns-sticky-slider__horizontal-section");
    if(stickySlider.length<1){
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    if(!CSS.supports("overflow:clip")){
        stickySlider.forEach((node) => {
            node.style.display = "none";
        });
    }
    let horizontalItem = $('.ns-sticky-slider__horizontal-item');
    let horizontalSection = $('.ns-sticky-slider__horizontal-section');
    let moveDistance;
    function calculateScroll() {
        // Desktop
        let itemsInView = 3;
        let scrollSpeed = 1.2;

        if (window.matchMedia('(max-width: 479px)').matches) {
            // Mobile Portrait
            itemsInView = 1;
            scrollSpeed = 1.2;
        } else if (window.matchMedia('(max-width: 767px)').matches) {
            // Mobile Landscape
            itemsInView = 1;
            scrollSpeed = 1.2;
        } else if (window.matchMedia('(max-width: 991px)').matches) {
            // Tablet
            itemsInView = 2;
            scrollSpeed = 1.2;
        }
        let moveAmount = horizontalItem.length - itemsInView;
        let minHeight =
            scrollSpeed * horizontalItem.outerWidth() * horizontalItem.length;
        if (moveAmount <= 0) {
            moveAmount = 0;
            minHeight = 0;
            // horizontalSection.css('height', '100vh');
        } else {
            horizontalSection.css('height', '200vh');
        }
        moveDistance = horizontalItem.outerWidth() * moveAmount;
        horizontalSection.css('min-height', minHeight + 'px');
    }
    calculateScroll();
    window.onresize = function () {
        calculateScroll();
    };

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.ns-sticky-slider__horizontal-trigger',
            // trigger element - viewport
            start: 'top top',
            end: 'bottom top',
            invalidateOnRefresh: true,
            scrub: 1,
        },
    });
    tl.to('.ns-sticky-slider__horizontal-section .ns-sticky-slider__list', {
        x: () => -moveDistance,
        duration: 1,
    });
});
